import React, { memo, useMemo } from 'react';
import { Stack, Typography, Card } from 'investira.react.components';
import { isAvaliacaoDoneStatus, isAvaliacaoWaitingStatus } from './_shared/avaliacaoStatus';
const AvaliacoesHighlights = memo(props => {
  const {
    data = []
  } = props;
  const xMetrics = useMemo(() => {
    const xRows = Array.isArray(data) ? data : [];
    const waiting = xRows.filter(xItem => isAvaliacaoWaitingStatus(xItem?.status)).length;
    const done = xRows.filter(xItem => isAvaliacaoDoneStatus(xItem?.status)).length;
    return {
      total: xRows.length,
      waiting,
      done
    };
  }, [data]);
  return <>
      <Stack sx={{
      gap: 1,
      flex: 1,
      mb: 2
    }} direction>
        <Stack gap={1} flex={1}>
          <Card sx={{
          flex: 1,
          display: 'flex',
          minHeight: 0
        }}>
            <Stack p={2} justifyContent="space-between">
              <Typography variant="caption" color="textSecondary" sx={{
              fontWeight: 500
            }}>
                Total de Avaliações
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{xMetrics.total}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Stack gap={1} flex={1}>
          <Card sx={{
          flex: 1,
          display: 'flex',
          minHeight: 0
        }}>
            <Stack p={2} justifyContent="space-between">
              <Typography variant="caption" color="textSecondary" sx={{
              fontWeight: 500
            }}>
                Pendentes
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{xMetrics.waiting}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Stack gap={1} flex={1}>
          <Card sx={{
          flex: 1,
          display: 'flex',
          minHeight: 0
        }}>
            <Stack p={2} justifyContent="space-between">
              <Typography variant="caption" color="textSecondary" sx={{
              fontWeight: 500
            }}>
                Concluídas
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{xMetrics.done}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>
    </>;
});
export default AvaliacoesHighlights;
